import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BELeatherCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Leather Technology",
    shortName: "B.E. Leather",
    duration: "4 years",
    description: "Specialized engineering program focused on leather processing, footwear technology, and leather goods manufacturing",
    overview: "Bachelor of Engineering in Leather Technology (B.E. Leather) is a 4-year undergraduate program that deals with the science and technology of leather processing, tanning, finishing, and leather product manufacturing. This course covers hide and skin processing, chemical technology, footwear design, quality control, and environmental aspects of leather industry, preparing students for careers in leather, footwear, and allied industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in chemistry and materials technology"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Leather Technology",
          "Biology and Anatomy"
        ]
      },
      {
        year: 2,
        subjects: [
          "Organic Chemistry",
          "Biochemistry",
          "Hide and Skin Structure",
          "Tanning Chemistry",
          "Mechanical Engineering",
          "Material Science"
        ]
      },
      {
        year: 3,
        subjects: [
          "Leather Processing Technology",
          "Finishing Technology",
          "Footwear Technology",
          "Quality Control",
          "Leather Goods Manufacturing",
          "Environmental Engineering"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Leather Technology",
          "Footwear Design",
          "Industrial Management",
          "Pollution Control",
          "Project Work",
          "Entrepreneurship Development"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Leather Technologist",
        "Production Engineer",
        "Quality Control Manager",
        "Footwear Designer",
        "Process Engineer",
        "Environmental Engineer",
        "R&D Engineer",
        "Export Manager",
        "Technical Consultant",
        "Entrepreneur"
      ],
      industries: [
        "Leather Processing Industry",
        "Footwear Manufacturing",
        "Leather Goods Manufacturing",
        "Chemical Industry",
        "Export Houses",
        "Fashion Industry",
        "Research Institutions",
        "Government Organizations",
        "Consulting Firms",
        "Environmental Organizations"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-25 LPA (Experienced)",
      topRecruiters: [
        "Bata India, Liberty Shoes",
        "VKC Footsteps, Relaxo",
        "Farida Shoes, Action Shoes",
        "CLE, CSIR-CLRI",
        "Export Houses, Trading Companies",
        "Chemical Companies (Clariant, LANXESS)"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Anna University - Central Leather Research Institute",
        location: "Chennai",
        fees: "₹2,50,000",
        ranking: "Premier Leather Institute"
      },
      {
        name: "Government College of Technology",
        location: "Coimbatore",
        fees: "₹2,00,000",
        ranking: "Government Technical College"
      },
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹3,00,000",
        ranking: "State University"
      },
      {
        name: "Private Engineering Colleges",
        location: "Various locations",
        fees: "₹4,00,000 - ₹8,00,000",
        ranking: "AICTE Approved"
      }
    ],

    skills: [
      "Leather Processing",
      "Chemical Analysis",
      "Quality Testing",
      "Footwear Design",
      "Production Management",
      "Environmental Compliance",
      "Research and Development",
      "International Trade",
      "CAD Design",
      "Business Management"
    ],

    futureScope: "Growing opportunities with sustainable leather technologies, eco-friendly processing methods, fashion industry growth, and increasing exports of leather products from India.",

    faqs: [
      {
        question: "What career opportunities exist in Leather Technology?",
        answer: "Opportunities include leather processing companies, footwear manufacturers, export houses, research institutions, chemical companies, and entrepreneurship in leather goods."
      },
      {
        question: "Is there focus on environmental aspects?",
        answer: "Yes, modern leather technology emphasizes eco-friendly processing, waste treatment, cleaner production methods, and sustainable leather manufacturing practices."
      },
      {
        question: "Can I work in the fashion industry?",
        answer: "Yes, leather technologists work with fashion brands, footwear designers, and luxury goods manufacturers for product development and quality assurance."
      },
      {
        question: "What about export opportunities?",
        answer: "Excellent export opportunities exist as India is a major exporter of leather products, with strong demand for technical expertise in international markets."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BELeatherCoursePage;
